<template>
  <TemplateDetailLayout class="content-tab">
    <template #option-heading>
      <AppHeading :text="tabTitle" tag="h3" />
    </template>
    <template #option-content>
      <!-- title -->
      <div class="content-tab__title tab-section">
        <AppHeading text="Título" tag="h4" />
        <AppInput v-model="template.title" class="content-tab__title-text" @input="updateTitle" />
        <!-- error -->
        <AppInputError v-if="!template.title" message="Es necesario el título" />
      </div>
      <!-- short description -->
      <div class="content-tab__short-description tab-section">
        <AppHeading text="Descripción corta" tag="h4">
          <template #after-text>
            <AppTooltip message="Se mostrará cuando el cliente quiera añadir una nueva acción" />
          </template>
        </AppHeading>
        <!-- marked text -->
        <MarkdownMarkedText
          v-show="!isShortDescriptionEditorOpen"
          place-holder="Añade una descripción corta..."
          :text="template.short_description"
          @click="toggleMarkdownEditor"
        />
        <!-- editor -->
        <MarkdownEditor
          compact
          placeholder="Añadir descripción corta..."
          :to-parse="template.short_description"
          :show-editor="isShortDescriptionEditorOpen"
          @edited="updateShortDescription"
          @canceled="toggleMarkdownEditor"
        />
      </div>
      <!-- description -->
      <div class="content-tab__description tab-section">
        <AppHeading text="Descripción" tag="h4">
          <template #after-text>
            <AppTooltip message="Se mostrará en la tarjeta de la acción" />
          </template>
        </AppHeading>

        <!-- marked text -->
        <MarkdownMarkedText
          v-show="!isDescriptionEditorOpen"
          place-holder="Añade una descripción detallada..."
          :text="template.description"
          @click="toggleMarkdownEditor($event, true)"
        />
        <!-- editor -->
        <MarkdownEditor
          placeholder="Añadir descripción detallada..."
          :to-parse="template.description"
          :show-editor="isDescriptionEditorOpen"
          @edited="updateDescription"
          @canceled="toggleMarkdownEditor($event, true)"
        />
      </div>
      <!-- tasks -->
      <div class="content-tab__tasks tab-section">
        <AppHeading text="Tareas" tag="h4" />
        <Checklists :listing="template.checklists" />
      </div>
    </template>
  </TemplateDetailLayout>
</template>

<script>
// Utilities
import AppInput from 'Ui/AppInput'
import AppTooltip from 'Ui/AppTooltip'
import AppHeading from 'Ui/AppHeading'
import Checklists from 'Modules/Checklists'
import AppInputError from 'Ui/AppInputError'
import TemplateDetailLayout from 'Layouts/TemplateDetailLayout'
import MarkdownEditor from 'Components/Markdown/MarkdownEditor'
import MarkdownMarkedText from 'Components/Markdown/MarkdownMarkedText'

export default {
  name: 'TemplateEditPageContent',

  components: {
    AppInput,
    AppHeading,
    Checklists,
    AppTooltip,
    AppInputError,
    MarkdownEditor,
    MarkdownMarkedText,
    TemplateDetailLayout,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    tabTitle: {
      type: String,
      default: 'Contenido',
    },
  },

  data() {
    return {
      isDescriptionEditorOpen: false,
      isShortDescriptionEditorOpen: false,
    }
  },
  methods: {
    toggleMarkdownEditor(event, isDescription = false) {
      if (event && event.target?.nodeName === 'A') return
      if (isDescription) {
        this.isDescriptionEditorOpen = !this.isDescriptionEditorOpen
      } else {
        this.isShortDescriptionEditorOpen = !this.isShortDescriptionEditorOpen
      }
    },

    updateTitle(value) {
      if (!value) return
      const data = {
        title: value,
      }
      this.$store.dispatch('templates/updateTemplateDraftTitle', data)
    },

    async updateShortDescription(value) {
      const data = {
        short_description: value,
      }
      await this.$store.dispatch('templates/updateTemplateDraft', data)
      this.toggleMarkdownEditor()
    },

    async updateDescription(value) {
      const data = {
        description: value,
      }
      await this.$store.dispatch('templates/updateTemplateDraft', data)
      this.toggleMarkdownEditor(null, true)
    },
  },
  computed: {
    isMarkdownEditorOpen() {
      return this.refReady && this.$refs.markdown.showMarkdownEditor
    },

    templateDescription() {
      return this.template[`description`]
    },
  },
}
</script>

<style scoped>
.tab-section:not(:first-of-type) {
  margin-top: 20px;
}

.content-tab__title-text {
  font-size: 21px;
  font-weight: 600;
  color: var(--rgba--light-blue);
}

.markdown__marked-text:hover {
  cursor: pointer;
  background-color: var(--c-secondary-400);
}

.content-tab__short-description >>> .markdown__marked-text * {
  color: var(--c-secondary);
}

.content-tab >>> .checklist__body {
  background-color: transparent;
}
</style>
